import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

class ConfirmAceitaPreFatura extends React.Component {
  state = {};

  handleClose = value => {
    //this.props.close(value);
  };

  render() {
    const { open } = this.props;
    return (
      <div>
        <Dialog
          open={open}
          onClose={this.handleClose(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Confirmação"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Confirma aprovar a fatura?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose(false)} color="primary" autoFocus>
              Não
            </Button>
            <Button onClick={this.handleClose(true)} color="primary">
              Sim
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default ConfirmAceitaPreFatura;
